const state = {
  notificationMessageObject: {},
  notificationTextMessage: "Notification message",
  notificationJsonMessage: [],
  notificationTitle: "Notification title",
  notificationIcon: "ti-info",
  notificationType: "info",
  textNotificationCount: 0,
  jsonNotificationCount: 0
};

const mutations = {
  SET_NOTIFICATION_MESSAGE_OBJECT(state, notificationMessageObject) {
    state.notificationMessageObject = notificationMessageObject;
  },
  SET_NOTIFICATION_TEXT_MESSAGE(state, notificationTextMessage) {
    state.notificationTextMessage = notificationTextMessage;
  },
  SET_NOTIFICATION_JSON_MESSAGE(state, notificationJsonMessage) {
    state.notificationJsonMessage = notificationJsonMessage;
  },
  ADD_NOTIFICATION_JSON_MESSAGE(state, notificationJsonMessage) {
    const messages = state.notificationJsonMessage;
    messages.push(notificationJsonMessage);
    state.notificationJsonMessage = messages;
  },
  SET_NOTIFICATION_TITLE(state, notificationTitle) {
    state.notificationTitle = notificationTitle;
  },
  SET_NOTIFICATION_ICON(state, notificationIcon) {
    state.notificationIcon = notificationIcon;
  },
  SET_NOTIFICATION_TYPE(state, notificationType) {
    state.notificationType = notificationType;
  },
  INCREASE_TEXT_NOTIFICATION_COUNT(state) {
    state.textNotificationCount += 1;
  },
  INCREASE_JSON_NOTIFICATION_COUNT(state) {
    state.jsonNotificationCount += 1;
  }
};

const actions = {
  saveNotificationMessageObject({ commit }, notificationMessageObject) {
    commit("SET_NOTIFICATION_MESSAGE_OBJECT", notificationMessageObject);
  },
  saveNotificationTextMessage({ commit }, notificationTextMessage) {
    commit("SET_NOTIFICATION_TEXT_MESSAGE", notificationTextMessage);
  },
  saveNotificationJsonMessage({ commit }, notificationJsonMessage) {
    commit("SET_NOTIFICATION_JSON_MESSAGE", notificationJsonMessage);
  },
  addNotificationJsonMessage({ commit }, notificationJsonMessage) {
    commit("ADD_NOTIFICATION_JSON_MESSAGE", notificationJsonMessage);
  },
  saveNotificationTitle({ commit }, notificationTitle) {
    commit("SET_NOTIFICATION_TITLE", notificationTitle);
  },
  saveIcon({ commit }, notificationIcon) {
    commit("SET_NOTIFICATION_ICON", notificationIcon);
  },
  saveType({ commit }, notificationType) {
    commit("SET_NOTIFICATION_TYPE", notificationType);
  },
  saveTextNotification({ commit }, textNotification) {
    commit(
      "SET_NOTIFICATION_TEXT_MESSAGE",
      textNotification.notificationTextMessage
    );
    commit("SET_NOTIFICATION_ICON", textNotification.notificationIcon);
    commit("SET_NOTIFICATION_TYPE", textNotification.notificationType);
    commit("INCREASE_TEXT_NOTIFICATION_COUNT");
  },
  saveJsonNotification({ commit }, jsonNotification) {
    commit(
      "SET_NOTIFICATION_JSON_MESSAGE",
      jsonNotification.notificationJsonMessage
    );
    commit("SET_NOTIFICATION_TITLE", jsonNotification.notificationTitle);
    commit("SET_NOTIFICATION_ICON", jsonNotification.notificationIcon);
    commit("SET_NOTIFICATION_TYPE", jsonNotification.notificationType);
    commit("INCREASE_JSON_NOTIFICATION_COUNT");
  }
};

const getters = {
  getNotificationMessageArray(state) {
    return Object.values(state.notificationMessageObject);
  },
  notificationTextMessage(state) {
    return state.notificationTextMessage;
  },
  notificationJsonMessage(state) {
    return Object.values(state.notificationJsonMessage);
    //return ["Message 1", "Message 2", "Message 3"];
  },
  notificationTitle(state) {
    return state.notificationTitle;
  },
  notificationIcon(state) {
    return state.notificationIcon;
  },
  notificationType(state) {
    return state.notificationType;
  },
  notificationCount(state) {
    return state.notificationCount;
  },
  textNotificationCount(state) {
    return state.textNotificationCount;
  },
  jsonNotificationCount(state) {
    return state.jsonNotificationCount;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
